module.exports = __webpack_public_path__ + "assets/img/Type E (54).7fb446c5.jpg";